<template>
  <fieldset>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Pixel ID *</div>
      </div>
      <input type="text" class="form-control" required v-model="pixelId" @input="onUpdate">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">CAPI Token *</div>
      </div>
      <input type="password" class="form-control" required v-model="capiToken" @input="onUpdate" autocomplete="new-password">
    </div>

    <div class="input-group mb-0">
      <div class="input-group-prepend">
        <div class="input-group-text">Test Event Code</div>
      </div>
      <input type="text" class="form-control" v-model="testEventCode" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const pixelId = ref(null);
const capiToken = ref(null);
const testEventCode = ref(null);
const serializedValue = computed(() => {
  return {
    pixel_id: pixelId.value,
    capi_token: capiToken.value,
    test_event_code: testEventCode.value || null
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    pixelId.value = modelValue.value.pixel_id;
    capiToken.value = modelValue.value.capi_token;
    testEventCode.value = modelValue.value.test_event_code;
  }
}, {
  immediate: true
});
</script>
